import { render, staticRenderFns } from "./OverviewPortfolioCard.vue?vue&type=template&id=210f2142&scoped=true&"
import script from "./OverviewPortfolioCard.vue?vue&type=script&lang=js&"
export * from "./OverviewPortfolioCard.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPortfolioCard.vue?vue&type=style&index=0&id=210f2142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f2142",
  null
  
)

export default component.exports